exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5.text-red{color:#fa2837}h6.title-modal{color:#777}", ""]);

// exports
